import { Row, Space, Button, Badge, Menu, Dropdown, Col } from 'antd';
import React, { useEffect, useState } from 'react';
import { getMachineList, getPrintReports } from '../../api/api';
import CustomTable from '../../components/_common/Table';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { UpdateMachineList } from '../../redux/reducers/machinelistSlice';
import { useNavigate } from 'react-router-dom';
import { DownOutlined, EditFilled, DeleteFilled, TagFilled } from '@ant-design/icons';
import _ from "lodash";



const MachineList = () => {

    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [permission, setPermission] = useState(false);

    const [type, setType] = useState("All");
    const [filteredData, setFilteredData] = useState([]);

    // const filterData = (data:any) => (formatter:any) => data.map( (item:any) => ({
    //     text: formatter(item),
    //     value: formatter(item)
    // }));

    const columns: ColumnsType<any> = [
        { title: 'کد ماشین', dataIndex: 'str_MachineCode', key: 'str_MachineCode' },
        { title: 'نام', dataIndex: 'str_MachineName', key: 'str_MachineName' },
        { title: 'نام درایور', dataIndex: 'Str_MachineDriverName', key: 'Str_MachineDriverName' },
        {
            title: 'درایور', dataIndex: 'hasDriver', key: 'hasDriver', render: (_, record) => (
                <Space size="middle">
                    <Badge status={record.hasDriver ? "success" : "warning"} text={record.hasDriver ? "دارد" : "ندارد"} />
                </Space>
            )
        },
        { title: 'نحوه اتصال', dataIndex: 'str_InstallationType', key: 'str_InstallationType' },
        { title: 'نحوه نصب', dataIndex: 'str_ConnectionType', key: 'str_ConnectionType' },
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
    ];

    const menu = (record: any) => (
        <Menu
            items={[
                {
                    key: "1",
                    label: "ویرایش",
                    onClick: () => navigate("/parsicuser/newMachine/" + record.prk_MachineInfo_AutoID),
                    icon: <EditFilled />,
                    disabled: !permission

                },
                {
                    key: "2",
                    label: "حذف",
                    onClick: () => removeOnClick(record.prk_MachineInfo_AutoID),
                    icon: <DeleteFilled />,
                    disabled: !permission

                }
            ]}
        />
    )

    useEffect(() => {

        loadMachines();
        if (myStore.auth.loginType === 'parsicuser') {
            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'Machine')
                    setPermission(item.isDetailAccess);
            });
        }
        else {
            setPermission(true);
        }
    }, [])

    const loadMachines = () => {
        getMachineList()
            .then((result: any) => {
                dispatch(UpdateMachineList({ machineList: result.data.data }))
                setFilteredData(result.data.data)
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                // TODO: notify by toast
            })

    }

    const addNewOnClick = () => {
        navigate("/parsicuser/newMachine");
    }

    const removeOnClick = (id: number) => {
        console.log(id);
    }

    function onChangeValue(event: any) {
        setType(event.target.value);

        switch (event.target.value) {
            case 'All':
                setFilteredData(myStore.machineList.list);
                break;
            case 'WithDriver':
                const _newFilter = myStore.machineList.list.filter((value: any) => {
                    return value.hasDriver == 1;
                });
                setFilteredData(_newFilter);
                break;
            case 'NoDriver':
                const newFilter = myStore.machineList.list.filter((value: any) => {
                    return value.hasDriver == 0;
                });
                setFilteredData(newFilter);
                break;

        }
    }

   

    return (

        <>
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                <Col>
                    <Space size="large">
                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                            }}>
                            <input
                                type="radio"
                                value="All"
                                name="type"
                                checked={type === "All"}
                                onChange={onChangeValue}
                            />
                            <span style={{ marginRight: 6 }}>همه</span>
                        </label>

                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                            }}>
                            <input
                                type="radio"
                                value="WithDriver"
                                name="type"
                                checked={type === "WithDriver"}
                                onChange={onChangeValue}
                            />
                            <span style={{ marginRight: 6 }}>با درایور</span>
                        </label>

                        <label
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                            }}
                        >
                            <input
                                type="radio"
                                value="NoDriver"
                                name="type"
                                checked={type === "NoDriver"}
                                onChange={onChangeValue}
                            />
                            <span>بدون درایور</span>
                        </label>
                    </Space>
                </Col>
            </Row>
            <Row style={{ marginTop: 16 }}>
                <CustomTable
                    columns={columns}
                    data={filteredData}
                    isloading={isLoading}
                    onAddClick={addNewOnClick}
                    permission={permission}
                />
            </Row>
        </>
    );
}


export default MachineList;